"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardDataArea = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardDataAreaMixin = require("../../mixins/components/PropertyCardDataAreaMixin");
var _Paragraph = require("../Paragraph/Paragraph");
var StyledPropertyCardDataArea = /*#__PURE__*/(0, _styledComponents.default)(_Paragraph.Paragraph).withConfig({
  displayName: "StyledPropertyCardDataArea",
  componentId: "c11n-8-107-0__sc-10i1r6-0"
})(["", ""], _PropertyCardDataAreaMixin.PropertyCardDataAreaMixin);
exports.StyledPropertyCardDataArea = StyledPropertyCardDataArea;